import React from 'react';
import { ShieldAlert } from 'lucide-react';

/**
 * EmergencyButton - Mobile-only floating emergency button
 * 
 * Features:
 * - Only visible on mobile (hidden on desktop where sidebar has it)
 * - Compact icon-only design on mobile
 * - Red styling for immediate recognition
 * - Opens emergency panel on click
 */
const EmergencyButton = ({ onClick, className = '' }) => {
  return (
    <button
      className={`emergency-button-mobile ${className}`}
      onClick={onClick}
      title="Emergency Procedures"
      aria-label="Open Emergency Procedures"
    >
      <ShieldAlert size={24} />
    </button>
  );
};

export default EmergencyButton;